import { setPrefetched } from './set-prefetched/index.tsx';
import { setRecentlySelectedItem } from './set-recently-selected-item/index.tsx';

export const actions = {
	setPrefetched,
	setRecentlySelectedItem,
};
